/**
 * Multi-language related operations
 */
import type {LocaleType} from '/#/config';

import i18n from "../i18n";
import {useLocaleStoreWithOut} from '@/store/modules/locale';
import {unref, computed} from 'vue';
import {StorageUtils} from 'xmgoing-utils';

function setI18nLanguage(locale: LocaleType) {
  const localeStore = useLocaleStoreWithOut();
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale;
  } else {
    (i18n.global.locale as any).value = locale;
  }
  localeStore.setLocaleInfo({locale});
}

export function useLocale() {
  const localeStore = useLocaleStoreWithOut();
  const getLocale = computed(() => localeStore.getLocale);
  const getShowLocalePicker = computed(() => localeStore.getShowPicker);

  const getAntdLocale = computed((): any => {
    return i18n.global.getLocaleMessage(unref(getLocale))?.antdLocale ?? {};
  });

  // Switching the language will change the locale of useI18n
  // And submit to configuration modification
  async function changeLocale(locale: LocaleType) {
    setI18nLanguage(locale);
    StorageUtils.addSessionItem("projectI18n", locale);
    StorageUtils.addItem("projectI18n", locale);
    return locale;
  }

  return {
    getLocale,
    getShowLocalePicker,
    changeLocale,
    getAntdLocale,
  };
}
